import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs/Rx';

@Injectable()
export class AccountService {
    constructor(private http: HttpClient) { }

    get(): Observable<any> {
        return this.http.get<HttpResponse<any>>('api/account').map((res: HttpResponse<any>) => res);
    }

    save(account: any): Observable<HttpResponse<any>> {
        return this.http.post<HttpResponse<any>>('api/account', account);
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/shared/auth/account.service.ts